_options$rowPlacement